import React from "react";

import type { ProcessedPickemEntry } from "@/hooks/firestore/betting/useEntries";

import cx from "classnames";
import { constructCurrency } from "common/currency";

import * as styles from "../bets/BetSummary.module.scss";

type PickemSummaryProps = {
  entry: ProcessedPickemEntry;
};

const PickemSummary = ({ entry }: PickemSummaryProps) => {
  const currency = entry.data.currency;
  const hasWon = entry.data.status === "WON" || entry.data.status === "PLACED";
  const showBonusBadge = entry.data.promoCash && hasWon;

  return (
    <div
      className={cx(styles.summary, styles.pickemSummary, {
        [styles.isWon]: hasWon,
      })}
    >
      <div>
        <span className={styles.label}>Place</span>
        <span className={styles.value}>{entry.data.place || "-"}</span>
        <div className={styles.circle}>@</div>
      </div>
      <div>
        <span className={styles.label}>Points</span>
        <span className={styles.value}>{entry.data.points}</span>
        <div
          className={cx(styles.circle, {
            [styles.hideOnMobile]: showBonusBadge,
          })}
        >
          =
        </div>
      </div>
      <div className={styles.payout}>
        <span className={styles.label}>Payout</span>
        <div className={styles.valueWrapper}>
          <span className={styles.value}>
            {constructCurrency(entry.data.payOut, {
              currencyType: currency,
              userCurrency: currency,
            })}
          </span>

          {showBonusBadge && <span className={styles.bonus}>bonus</span>}
        </div>
      </div>
    </div>
  );
};

export { PickemSummary };
